<template>
  <div class="task-config">
    <SelectInput
      :id="'task-type-select'"
      label="Select task type"
      :options="availableTaskTypes"
      v-model="localConfig.taskType"
      @update:model-value="onTaskTypeChange"
    />

    <div v-if="localConfig.taskType === 'add_activity'" class="mt-4">
      <div class="alert alert--info">Activity tracking coming soon</div>
    </div>

    <div v-else-if="localConfig.taskType === 'celebrate'" class="mt-4">
      <TextInput
        id="celebration-message"
        label="Celebration Message"
        v-model="localConfig.celebrationMessage"
        placeholder="Time to celebrate!"
      />
    </div>

    <div v-else-if="localConfig.taskType === 'proposal'" class="mt-4">
      <ProposalAutomationConfig v-model="localConfig.proposalConfig" />
    </div>
  </div>
</template>

<script>
  import { ref, watch } from 'vue';
  import SelectInput from '@/components/inputs/SelectInput.vue';
  import TextInput from '@/components/inputs/TextInput.vue';
  import ProposalAutomationConfig from './ProposalAutomationConfig.vue';

  export default {
    name: 'TaskConfig',

    components: {
      SelectInput,
      TextInput,
      ProposalAutomationConfig,
    },

    props: {
      modelValue: {
        type: Object,
        required: true,
      },
    },

    setup(props, { emit }) {
      const availableTaskTypes = [
        { label: 'Create proposal', value: 'proposal' },
        { label: 'Celebrate', value: 'celebrate' },
        { label: 'Add Activity to Lead (coming soon)', value: 'add_activity', disabled: true },
      ];

      const localConfig = ref({
        taskType: props.modelValue.taskType || null,
        celebrationMessage: props.modelValue.celebrationMessage || '',
        proposalConfig: props.modelValue.proposalConfig || {
          title: '',
          days_valid_amount: 30,
          client_notes: '',
          internal_notes: '',
          items: [],
        },
      });

      const onTaskTypeChange = () => {
        localConfig.value.celebrationMessage = '';
        emitUpdate();
      };

      const emitUpdate = () => {
        emit('update:config', { ...localConfig.value });
      };

      watch(
        localConfig.value,
        (newVal) => {
          emit('update:config', { ...newVal });
        },
        { deep: true }
      );

      return {
        localConfig,
        availableTaskTypes,
        onTaskTypeChange,
      };
    },
  };
</script>

<style scoped lang="scss">
  .task-config {
    .alert {
      font-style: italic;
      font-size: 0.875rem;
      a {
        text-decoration: underline;
      }
    }
  }
</style>
